// This file is auto-generated by scripts/generate-form-schema.ts
// DO NOT EDIT MANUALLY - run 'pnpm generate-schema' to regenerate

export type StaticFieldSchema = {
  key: string
  type: 'string' | 'number' | 'boolean' | 'object' | 'array' | 'enum'
  required: boolean
  component:
    | 'TextInput'
    | 'Select'
    | 'Checkbox'
    | 'Textarea'
    | 'NumberInput'
    | 'ArrayEditor'
  numberFormat?: 'integer' | 'float' | 'currency'
  options?:
    | Array<string>
    | Array<{ label: string; value: string; sublabel?: string }>
  nested?: Array<StaticFieldSchema>
  fullPath?: string
  description?: string
  /** The spec marks this field readOnly, so no request body may carry it. */
  readOnly?: boolean
}

export const usersUpdateRequestSchema: Array<StaticFieldSchema> = [
  {
    key: 'userType',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'userType',
    options: ['borrower', 'agent', 'service'],
  },
  {
    key: 'roles',
    type: 'array',
    required: false,
    component: 'ArrayEditor',
    fullPath: 'roles',
    nested: [
      {
        key: '0',
        type: 'string',
        required: true,
        component: 'TextInput',
        fullPath: 'roles[0]',
      },
    ],
  },
  {
    key: 'associatedPersonId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'associatedPersonId',
  },
  {
    key: 'borrowerId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'borrowerId',
  },
  {
    key: 'companyId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'companyId',
    readOnly: true,
  },
  {
    key: 'externalId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'externalId',
  },
  {
    key: 'status',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'status',
    options: ['inactive', 'active'],
  },
  {
    key: 'type',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'type',
    options: ['borrower', 'agent', 'service'],
  },
  {
    key: 'roleIds',
    type: 'array',
    required: false,
    component: 'ArrayEditor',
    fullPath: 'roleIds',
    nested: [
      {
        key: '0',
        type: 'string',
        required: true,
        component: 'TextInput',
        fullPath: 'roleIds[0]',
      },
    ],
  },
] as const

export const getFieldSchema = (path: string): StaticFieldSchema | undefined => {
  const findByPath = (
    fields: Array<StaticFieldSchema>,
    targetPath: string,
  ): StaticFieldSchema | undefined => {
    for (const field of fields) {
      if (field.fullPath === targetPath) {
        return field
      }
      if (field.nested) {
        const found = findByPath(field.nested, targetPath)
        if (found) return found
      }
    }
    return undefined
  }

  return findByPath(usersUpdateRequestSchema, path)
}

export const getAllPaths = (): Array<string> => {
  const extractPaths = (fields: Array<StaticFieldSchema>): Array<string> => {
    const paths: Array<string> = []
    for (const field of fields) {
      if (field.fullPath) {
        paths.push(field.fullPath)
      }
      if (field.nested) {
        paths.push(...extractPaths(field.nested))
      }
    }
    return paths
  }

  return extractPaths(usersUpdateRequestSchema)
}
